<template>
  <div class="inline-flex">
    <BaseButton small ghost :disabled="pending" @click="showConfirm"> Delete Channel </BaseButton>

    <Portal to="app-dialog" v-if="confirm">
      <BaseDialogDelete
        @confirmed="deleteChannel"
        @closed="showConfirm(false)"
        @rejected="showConfirm(false)"
      />
    </Portal>
  </div>
</template>

<script>
import { campaignChannelsClient } from '@/api/clients';

export default {
  props: {
    channel: {
      type: Object,
      required: true,
    },
    campaign: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      pending: false,
      confirm: false,
    };
  },
  methods: {
    setPending(value) {
      this.pending = value;
    },
    showConfirm(value) {
      this.confirm = value;
    },
    async deleteChannel() {
      try {
        this.setPending(true);

        await campaignChannelsClient.destroy(this.campaign.id, this.channel.id);

        this.$emit('deleted');
      } catch (error) {
        //
      } finally {
        this.setPending(false);
      }
    },
  },
};
</script>
